import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../components/custom_components/FlexRow'
import { OverviewBarChart } from '../../components/custom_components/OverviewBarChart'
import PerText from '../../components/custom_components/Text'
import { ScoreGoalType, ScoreGridsOverviewDto } from '../../types'

type Props = {
  evaluationOverview: ScoreGridsOverviewDto
  privateView: boolean
}

export type BarChartData = {
  type: string
  group: string
  prior?: number
  lastPreparation?: number
  last?: number
}

export const EvaluationOverviewContainer: FC<Props> = ({ privateView, evaluationOverview }) => {
  const [t] = useTranslation()
  const { lastAppraisalDate, lastAppraisalEmplPrepDate, priorAppraisalDate, scoreGoals } = evaluationOverview

  const data: BarChartData[] = Object.keys(ScoreGoalType).map((type) => {
    const score = scoreGoals.find((goal) => goal.viewId === type)
    const priorScore = score && score.lastResultEvaluation ? score.lastResultEvaluation : undefined
    const lastPreparationScore = score && score.employeeEvaluation ? score.employeeEvaluation : undefined
    const lastScore = score && score.resultEvaluation ? score.resultEvaluation : undefined
    return {
      type: t(`ownGrowthView.overview.chart.xAxisScoreType.${type}`),
      group: t(`ownGrowthView.overview.chart.xAxisScoreCategory.${type.split('_')[0]}`),
      prior: priorScore,
      lastPreparation: lastPreparationScore,
      last: lastScore,
    }
  })

  return (
    <PerFlexRow direction="column" align="middle">
      <div>
        <PerText appearance="tile-heading" mb="xs" ml="xxl">
          {t(`ownGrowthView.overview.title`)}
        </PerText>
        <OverviewBarChart
          data={data}
          lastAppraisalDate={lastAppraisalDate}
          lastAppraisalEmplPrepDate={lastAppraisalEmplPrepDate}
          priorAppraisalDate={priorAppraisalDate}
          privateView={privateView}
        />
      </div>
    </PerFlexRow>
  )
}
